<template>
  <div>
    <el-table :data="tableData" style="width: 100%; margin-top: 20px" border stripe>
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="NAME" label="供应商名称"></el-table-column>
      <el-table-column prop="CONTACT_NAME" label="联系人"></el-table-column>
      <el-table-column prop="CONTACT_PHONE" label="联系电话"></el-table-column>
      <el-table-column prop="STATUS" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.STATUS == 1">未报价</span>
          <span v-if="scope.row.STATUS == 2">已报价</span>
        </template>
      </el-table-column>
      <el-table-column prop="action" label="操作" v-if="fun_dic[103050101]">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="checkScName(scope.row)">查看大类</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination_box" v-show="totalCount > 10">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getActionFun } from 'api/login';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      totalCount: 0,
      pageSize: 15,
      currentPage: 1,
      //   提交状态
      status: Number(this.$route.params.status),
      PAGE_ID: '1030501', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 103050101: 0 },
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.getSupplierPrice();
    this.queryBeforeFun();
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 获取供应商比价列表
    getSupplierPrice() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 9,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        COMPARE_ID: Number(this.$route.params.id),
      };
      http.post(params).then((res) => {
        if (res.length == 0) {
          this.$message.show({ text: '暂无数据', type: 'success' });
        } else {
          this.tableData = res[0].RECORD_INFO;
          this.totalCount = res[0].TOTAL_COUNT;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getSupplierPrice();
    },
    // 查看某个供应商下的一级大类
    checkScName(row) {
      this.$router.push({
        path: `/scName/${this.$route.params.id}/${row.RECORD_ID}/${row.SUPPLIER_ID}/${this.$route.params.status}`,
        params: {
          compareId: this.$route.params.id, recordId: row.RECORD_ID, supplierId: row.SUPPLIER_ID, status: this.$route.params.status,
        },
      });
      sessionStorage.setItem('RECORD_ID', row.RECORD_ID);
      sessionStorage.setItem('SUPPLIER_ID', row.SUPPLIER_ID);
    },
  },
};
</script>
<style scoped>
.pagination_box {
  float: right;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/supplierDetail.vue